module.exports = __webpack_public_path__ + "edb5455a521a82376a347ae6d5bf3a41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/bouteille-contour.svg
// module id = 733
// module chunks = 0